import * as S from "./AlertPwBox.style";
import { ReactComponent as IconChecked } from "@/styles/assets/svg/icon_checked_large.svg";

export const AlertPwBox = () => {
  return (
    <S.AlertMessageBox>
      <IconChecked />
      <S.AlertMessageText>
        <span>비밀번호가</span>
        <span>변경되었습니다.</span>
      </S.AlertMessageText>
    </S.AlertMessageBox>
  );
};
